import type { Company } from '@pn/core/domain/intel/company';
import { handleError } from '@pn/core/errors/handleError';
import { companiesActions, useCompaniesStorage } from '@pn/core/storage';
import { apiCompanyProvider } from '@pn/services/api/company/apiCompanyProvider';
import { isNil } from 'lodash-es';
import React from 'react';

let isLoading = false;

async function getCompaniesBySearchTerm(companyId: Company['id']) {
  try {
    if (isLoading) return;
    isLoading = true;
    companiesActions().request();

    const company = await apiCompanyProvider.getCompanyById(companyId);

    companiesActions().load(company);
  } catch (error) {
    handleError({
      error,
      onError: companiesActions().error,
      notify: 'Failed to find company by id',
    });
  }
  isLoading = false;
}

export function useAutoLoadCompanyById() {
  const { selectedCompany, selectedCompanyId } = useCompaniesStorage();
  const companyIsAlreadyLoaded = selectedCompanyId === selectedCompany?.id;
  React.useEffect(() => {
    if (companyIsAlreadyLoaded || isNil(selectedCompanyId)) return;
    getCompaniesBySearchTerm(selectedCompanyId);
  }, [selectedCompanyId, companyIsAlreadyLoaded]);
}
